import { css } from '@/styled-system/css';

export const inputChipAvatarStyles = css.raw({
  display: 'inline-flex',
  marginInlineEnd: 'Chip.gap.leading',
});
